var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.51432L17.5 5.34766V15.3477L2.5 12.0143V9.51432Z",
    stroke: "#67768E",
    strokeWidth: 1.34563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66664 14.349C9.5791 14.6663 9.4299 14.9633 9.22756 15.223C9.02523 15.4827 8.77373 15.7 8.48741 15.8625C8.2011 16.025 7.88558 16.1296 7.55888 16.1701C7.23217 16.2107 6.90067 16.1865 6.58331 16.099C6.26595 16.0114 5.96894 15.8622 5.70924 15.6599C5.44954 15.4575 5.23223 15.206 5.06973 14.9197C4.90723 14.6334 4.80271 14.3179 4.76215 13.9912C4.72158 13.6645 4.74576 13.333 4.83331 13.0156",
    stroke: "#67768E",
    strokeWidth: 1.34563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/Announcement.86dc843eaa4b82be8aa280fd1d876326.svg";
export { ForwardRef as ReactComponent };